import { render, staticRenderFns } from "./mainwarp.vue?vue&type=template&id=d8f30f80&scoped=true"
import script from "./mainwarp.vue?vue&type=script&lang=js"
export * from "./mainwarp.vue?vue&type=script&lang=js"
import style0 from "./mainwarp.vue?vue&type=style&index=0&id=d8f30f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f30f80",
  null
  
)

export default component.exports